module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/guests_lv_mobile-c687742278345d701d3463b162cb863a.webp";